import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import SystemNotification from '../../../SystemNotification';
import Heading from '../../../a11y/headings/Heading';
import { useOnOutsideClick } from '../../../utils/hooks/useOnOutsideClick';
import s from './GroupPromptNotification.scss';
var GroupPromptNotification = function (_a) {
    var id = _a.id, queueName = _a.queueName, removeNotification = _a.removeNotification;
    var rootRef = useRef(null);
    useOnOutsideClick([rootRef], function () { return removeNotification(id); }, true);
    var t = useTranslation().t;
    return (React.createElement(SystemNotification, { multiLine: true, withCloseButton: true, className: s['root'], closeButtonClassName: s['close-button'], textClassName: s['text'], customIcon: (React.createElement("img", { className: s['icon'], alt: "IL44", src: "https://st.deviantart.net/eclipse/promos/il44.svg" })), onClose: function () { return removeNotification(id); } },
        React.createElement("div", { ref: rootRef, className: s['notification-text'] },
            React.createElement(Heading, { className: s['notification-heading'] }, t('deviationview.groupPrompt.title')),
            React.createElement("span", null, t('deviationview.groupPrompt.message')))));
};
GroupPromptNotification.displayName = 'GroupPromptNotification';
export default GroupPromptNotification;
//# sourceMappingURL=GroupPromptNotification.js.map